import { PackageCard } from './PackageCard';

interface PackageListProps {
  packages: any[];
  onItemClick?: (item: any) => void;
}

export function PackageList({
  packages,
  onItemClick,
}: Readonly<PackageListProps>) {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      {packages.map((item) => (
        <button
          key={item.id}
          className={`no-underline hover:bg-transparent hover:shadow-none ${onItemClick ? 'cursor-pointer' : ''}`}
          onClick={() => onItemClick && onItemClick(item)}
        >
          <PackageCard item={item} className='bg-wl-background' />
        </button>
      ))}
    </div>
  );
}
